import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"display":"block"},
  viewBox: "0 0 200 300"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#0088d9",
      d: "M3.259 183.382c-1.817 0-3.251 1.516-3.186 3.331 2.242 62.531 53.643 112.534 116.72 112.534s114.461-50 116.708-112.525c.066-1.821-1.374-3.343-3.196-3.343H168.81c-1.636 0-3.046 1.338-3.174 2.969-1.985 25.247-23.087 45.117-48.843 45.117-30.902 0-43.398-26.241-43.4-26.245-3.987-7.513-5.149-14.838-5.48-18.934-.132-1.646-1.523-2.907-3.175-2.907z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#ff932c",
      d: "m194.943 18.122-127.16 70.31v74.643l129.15-71.414a5.32 5.32 0 0 0 2.744-4.653V20.914c0-2.43-2.607-3.967-4.734-2.792Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#e32851",
      d: "M67.783 3.196c0-2.53-2.802-4.053-4.925-2.678L2.427 39.654A5.32 5.32 0 0 0 0 44.116V159.89a3.186 3.186 0 0 0 3.186 3.186h64.597z"
    }, null, -1)
  ]))]))
}
export default { render: render }